module.exports = __webpack_public_path__ + "img/india.d51ec02e.png";